import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    intakeFormBackThunk,
    submitIntakeFormThunk,
    updateIntakeFormPetThunk
} from 'actions/intakeForm/IntakeFormActions';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import { PetForm } from 'components/Pet/Form/PetForm';
import { PetOption } from 'components/Pet/Option/PetOption';
import { Button } from 'components/UI/Button/Button';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIntakeFormPets } from 'reducers/intakeForm/IntakeFormSelectors';
import { Pet } from 'types/Pet';

import classes from './IntakeFormPetList.module.scss';

export const IntakeFormPetList: React.FC = () => {
    const dispatch = useDispatch();
    const pets = useSelector(getIntakeFormPets);

    const [editingPetUuid, setEditingPetUuid] = React.useState<string | null>(null);

    const editPetHandler = (uuid: string) => {
        setEditingPetUuid(uuid);
    };

    const editedPetHandler = async (pet: Pet) => {
        await dispatch(updateIntakeFormPetThunk(pet));

        setEditingPetUuid(null);
    };

    const addPetHandler = () => {
        dispatch(intakeFormBackThunk());
    };

    const submitHandler = () => {
        dispatch(submitIntakeFormThunk());
    };

    return (
        <LeftColumn
            footer={
                <Button fullWidth onClick={submitHandler}>
                    Submit
                </Button>
            }
        >
            <h1 className="h1 underlined">Pets added</h1>

            {pets.map(pet => (
                <div key={pet.uuid} className="w-full">
                    {editingPetUuid === pet.uuid ? (
                        <PetForm
                            pet={pet}
                            showSubmitButton
                            className={classes.editForm}
                            submitButtonLabel="Update"
                            onSubmit={editedPetHandler}
                        />
                    ) : (
                        <PetOption hideCheckbox pet={pet} onEdit={() => editPetHandler(pet.uuid)} />
                    )}
                </div>
            ))}

            <Button variant="link" className={classes.addPetButton} onClick={addPetHandler}>
                <FontAwesomeIcon icon={faPlus} />

                <span>Add new pet</span>
            </Button>
        </LeftColumn>
    );
};
